export const addProtection = () => {
  const handleContextMenu = (e) => {
    const target = e.target && e.target.nodeType === 1 ? e.target : null; // 1 = ELEMENT_NODE
    if (!target) {
      return;
    }

    const isImg = (target.tagName || '').toLowerCase() === 'img';
    const isProtected = typeof target.closest === 'function' && target.closest('.-protected');
    const isNoContextMenu = typeof target.closest === 'function' && target.closest('.-no-context-menu');

    if (isImg || isProtected || isNoContextMenu) {
      e.preventDefault();
    }
  };

  // Use capture so we can prevent earlier in the event phase.
  document.addEventListener('contextmenu', handleContextMenu, true);

  return () => {
    document.removeEventListener('contextmenu', handleContextMenu, true);
  };
};
